export default "__VITE_ASSET__CddTUU69__"